import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Select, SelectField, Paragraph, Input } from 'kenobi-ui';
import Component from '@reach/component-component';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "select"
    }}>{`Select`}</h1>
    <h3 {...{
      "id": "select-is-basically-just-a-wrapper-around-react-select"
    }}><inlineCode parentName="h3">{`Select`}</inlineCode>{` is basically just a wrapper around `}<a parentName="h3" {...{
        "href": "https://github.com/JedWatson/react-select"
      }}>{`react-select`}</a>{`.`}</h3>
    <h3 {...{
      "id": "all-react-select-functionality-will-work-as-expected-if-not-please-reach-out"
    }}>{`All `}<inlineCode parentName="h3">{`react-select`}</inlineCode>{` functionality will work as expected, if not please reach out!`}</h3>
    <h3 {...{
      "id": "select-provides-kenobi-theming-to-react-select-the-selectfield-component-provides-labels-etc"
    }}><inlineCode parentName="h3">{`Select`}</inlineCode>{` provides Kenobi theming to `}<inlineCode parentName="h3">{`react-select`}</inlineCode>{`. The `}<inlineCode parentName="h3">{`SelectField`}</inlineCode>{` component provides Labels etc.`}</h3>
    <h3 {...{
      "id": "for-a-list-of-all-available-react-select-props-go-to-docs"
    }}>{`For a list of all available `}<inlineCode parentName="h3">{`react-select`}</inlineCode>{` props go to `}<a parentName="h3" {...{
        "href": "https://react-select.com/props"
      }}>{`Docs`}</a>{`.`}</h3>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`This is a controlled example using `}<inlineCode parentName="p">{`value`}</inlineCode>{` and `}<inlineCode parentName="p">{`onChange`}</inlineCode>{`.`}</p>
    <Playground __position={0} __code={'<Component initialState={{ value: \'\', label: \'\' }}>\n  {({ state, setState }) => (\n    <React.Fragment>\n      <Select\n        name=\"icecream-flavours\"\n        value={state}\n        options={[\n          { value: \'chocolate\', label: \'Chocolate\' },\n          { value: \'strawberry\', label: \'Strawberry\' },\n          { value: \'vanilla\', label: \'Vanilla\' },\n        ]}\n        onChange={e => setState(e)}\n      />\n      <div style={{ marginTop: \'1rem\' }}>\n        <Paragraph>\n          {state.value\n            ? `You have chosen ${state.label}!`\n            : \'Please choose a flavour\'}\n        </Paragraph>\n      </div>\n    </React.Fragment>\n  )}\n</Component>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Select,
      SelectField,
      Paragraph,
      Input,
      Component
    }} mdxType="Playground">
  <Component initialState={{
        value: '',
        label: ''
      }} mdxType="Component">
    {({
          state,
          setState
        }) => <React.Fragment>
        <Select name="icecream-flavours" value={state} options={[{
            value: 'chocolate',
            label: 'Chocolate'
          }, {
            value: 'strawberry',
            label: 'Strawberry'
          }, {
            value: 'vanilla',
            label: 'Vanilla'
          }]} onChange={e => setState(e)} mdxType="Select" />
        <div style={{
            marginTop: '1rem'
          }}>
          <Paragraph mdxType="Paragraph">
            {state.value ? `You have chosen ${state.label}!` : 'Please choose a flavour'}
          </Paragraph>
        </div>
      </React.Fragment>}
  </Component>
    </Playground>
    <h2 {...{
      "id": "multi-select"
    }}>{`Multi select`}</h2>
    <p>{`This is an uncontrolled example. You will have to provide `}<inlineCode parentName="p">{`value`}</inlineCode>{` and `}<inlineCode parentName="p">{`onChange`}</inlineCode>{` to make it controlled.`}</p>
    <Playground __position={1} __code={'<Select\n  isMulti\n  name=\"icecream-flavours\"\n  options={[\n    { value: \'chocolate\', label: \'Chocolate\' },\n    { value: \'strawberry\', label: \'Strawberry\' },\n    { value: \'vanilla\', label: \'Vanilla\' },\n    { value: \'pistachio\', label: \'Pistachio\' },\n    { value: \'cookies-and-cream\', label: \'Cookies & Cream\' },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Select,
      SelectField,
      Paragraph,
      Input,
      Component
    }} mdxType="Playground">
  <Select isMulti name="icecream-flavours" options={[{
        value: 'chocolate',
        label: 'Chocolate'
      }, {
        value: 'strawberry',
        label: 'Strawberry'
      }, {
        value: 'vanilla',
        label: 'Vanilla'
      }, {
        value: 'pistachio',
        label: 'Pistachio'
      }, {
        value: 'cookies-and-cream',
        label: 'Cookies & Cream'
      }]} mdxType="Select" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      